/**
 * @fileoverview gRPC-Web generated client stub for witbooking.ari.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_type_money_pb = require('../../../google/type/money_pb.js')

var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js')

var witbooking_ari_v1_static_ari_pb = require('../../../witbooking/ari/v1/static_ari_pb.js')

var witbooking_ari_v1_domain_pb = require('../../../witbooking/ari/v1/domain_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.ari = {};
proto.witbooking.ari.v1 = require('./ari_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.ari.v1.AriAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.ari.v1.AriAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.ARIRequest,
 *   !proto.witbooking.ari.v1.ARIResponse>}
 */
const methodDescriptor_AriAPI_GetARI = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/GetARI',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.ARIRequest,
  proto.witbooking.ari.v1.ARIResponse,
  /**
   * @param {!proto.witbooking.ari.v1.ARIRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.ARIResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.ARIRequest,
 *   !proto.witbooking.ari.v1.ARIResponse>}
 */
const methodInfo_AriAPI_GetARI = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.ARIResponse,
  /**
   * @param {!proto.witbooking.ari.v1.ARIRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.ARIResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.ARIRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.ARIResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.ARIResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.getARI =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetARI',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetARI,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.ARIRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.ARIResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.getARI =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetARI',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetARI);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.GetRawAriRequest,
 *   !proto.witbooking.ari.v1.GetRawAriResponse>}
 */
const methodDescriptor_AriAPI_GetRawAri = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/GetRawAri',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.GetRawAriRequest,
  proto.witbooking.ari.v1.GetRawAriResponse,
  /**
   * @param {!proto.witbooking.ari.v1.GetRawAriRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.GetRawAriResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.GetRawAriRequest,
 *   !proto.witbooking.ari.v1.GetRawAriResponse>}
 */
const methodInfo_AriAPI_GetRawAri = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.GetRawAriResponse,
  /**
   * @param {!proto.witbooking.ari.v1.GetRawAriRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.GetRawAriResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.GetRawAriRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.GetRawAriResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.GetRawAriResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.getRawAri =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetRawAri',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetRawAri,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.GetRawAriRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.GetRawAriResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.getRawAri =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetRawAri',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetRawAri);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.UpdateAriRequest,
 *   !proto.witbooking.ari.v1.UpdateAriResponse>}
 */
const methodDescriptor_AriAPI_UpdateAri = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/UpdateAri',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.UpdateAriRequest,
  proto.witbooking.ari.v1.UpdateAriResponse,
  /**
   * @param {!proto.witbooking.ari.v1.UpdateAriRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.UpdateAriResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.UpdateAriRequest,
 *   !proto.witbooking.ari.v1.UpdateAriResponse>}
 */
const methodInfo_AriAPI_UpdateAri = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.UpdateAriResponse,
  /**
   * @param {!proto.witbooking.ari.v1.UpdateAriRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.UpdateAriResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.UpdateAriRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.UpdateAriResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.UpdateAriResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.updateAri =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/UpdateAri',
      request,
      metadata || {},
      methodDescriptor_AriAPI_UpdateAri,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.UpdateAriRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.UpdateAriResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.updateAri =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/UpdateAri',
      request,
      metadata || {},
      methodDescriptor_AriAPI_UpdateAri);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.SaveInventoryStaticDataRequest,
 *   !proto.witbooking.ari.v1.SaveInventoryStaticDataResponse>}
 */
const methodDescriptor_AriAPI_SaveInventoryStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/SaveInventoryStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.SaveInventoryStaticDataRequest,
  proto.witbooking.ari.v1.SaveInventoryStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.SaveInventoryStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.SaveInventoryStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.SaveInventoryStaticDataRequest,
 *   !proto.witbooking.ari.v1.SaveInventoryStaticDataResponse>}
 */
const methodInfo_AriAPI_SaveInventoryStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.SaveInventoryStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.SaveInventoryStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.SaveInventoryStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.SaveInventoryStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.SaveInventoryStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.SaveInventoryStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.saveInventoryStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/SaveInventoryStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_SaveInventoryStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.SaveInventoryStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.SaveInventoryStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.saveInventoryStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/SaveInventoryStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_SaveInventoryStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.GetInventoryStaticDataRequest,
 *   !proto.witbooking.ari.v1.InventoryStaticDataResponse>}
 */
const methodDescriptor_AriAPI_GetInventoryStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/GetInventoryStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.GetInventoryStaticDataRequest,
  proto.witbooking.ari.v1.InventoryStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.GetInventoryStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.InventoryStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.GetInventoryStaticDataRequest,
 *   !proto.witbooking.ari.v1.InventoryStaticDataResponse>}
 */
const methodInfo_AriAPI_GetInventoryStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.InventoryStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.GetInventoryStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.InventoryStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.GetInventoryStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.InventoryStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.InventoryStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.getInventoryStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetInventoryStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetInventoryStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.GetInventoryStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.InventoryStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.getInventoryStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetInventoryStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetInventoryStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.ListInventoryStaticDataRequest,
 *   !proto.witbooking.ari.v1.InventoryStaticDataResponse>}
 */
const methodDescriptor_AriAPI_ListInventoryStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/ListInventoryStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.ListInventoryStaticDataRequest,
  proto.witbooking.ari.v1.InventoryStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.ListInventoryStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.InventoryStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.ListInventoryStaticDataRequest,
 *   !proto.witbooking.ari.v1.InventoryStaticDataResponse>}
 */
const methodInfo_AriAPI_ListInventoryStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.InventoryStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.ListInventoryStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.InventoryStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.ListInventoryStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.InventoryStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.InventoryStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.listInventoryStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/ListInventoryStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_ListInventoryStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.ListInventoryStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.InventoryStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.listInventoryStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/ListInventoryStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_ListInventoryStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse>}
 */
const methodDescriptor_AriAPI_DeleteInventoryStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/DeleteInventoryStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest,
  proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse>}
 */
const methodInfo_AriAPI_DeleteInventoryStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.deleteInventoryStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteInventoryStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteInventoryStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.DeleteInventoryStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.deleteInventoryStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteInventoryStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteInventoryStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse>}
 */
const methodDescriptor_AriAPI_DeleteMultiInventoryStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/DeleteMultiInventoryStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest,
  proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse>}
 */
const methodInfo_AriAPI_DeleteMultiInventoryStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.deleteMultiInventoryStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteMultiInventoryStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteMultiInventoryStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.DeleteMultiInventoryStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.DeleteInventoryStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.deleteMultiInventoryStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteMultiInventoryStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteMultiInventoryStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.SaveExtraStaticDataRequest,
 *   !proto.witbooking.ari.v1.SaveExtraStaticDataResponse>}
 */
const methodDescriptor_AriAPI_SaveExtraStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/SaveExtraStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.SaveExtraStaticDataRequest,
  proto.witbooking.ari.v1.SaveExtraStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.SaveExtraStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.SaveExtraStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.SaveExtraStaticDataRequest,
 *   !proto.witbooking.ari.v1.SaveExtraStaticDataResponse>}
 */
const methodInfo_AriAPI_SaveExtraStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.SaveExtraStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.SaveExtraStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.SaveExtraStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.SaveExtraStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.SaveExtraStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.SaveExtraStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.saveExtraStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/SaveExtraStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_SaveExtraStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.SaveExtraStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.SaveExtraStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.saveExtraStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/SaveExtraStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_SaveExtraStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.GetExtraStaticDataRequest,
 *   !proto.witbooking.ari.v1.ExtraStaticDataResponse>}
 */
const methodDescriptor_AriAPI_GetExtraStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/GetExtraStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.GetExtraStaticDataRequest,
  proto.witbooking.ari.v1.ExtraStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.GetExtraStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.ExtraStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.GetExtraStaticDataRequest,
 *   !proto.witbooking.ari.v1.ExtraStaticDataResponse>}
 */
const methodInfo_AriAPI_GetExtraStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.ExtraStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.GetExtraStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.ExtraStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.GetExtraStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.ExtraStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.ExtraStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.getExtraStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetExtraStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetExtraStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.GetExtraStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.ExtraStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.getExtraStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetExtraStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetExtraStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.ListExtraStaticDataRequest,
 *   !proto.witbooking.ari.v1.ExtraStaticDataResponse>}
 */
const methodDescriptor_AriAPI_ListExtraStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/ListExtraStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.ListExtraStaticDataRequest,
  proto.witbooking.ari.v1.ExtraStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.ListExtraStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.ExtraStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.ListExtraStaticDataRequest,
 *   !proto.witbooking.ari.v1.ExtraStaticDataResponse>}
 */
const methodInfo_AriAPI_ListExtraStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.ExtraStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.ListExtraStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.ExtraStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.ListExtraStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.ExtraStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.ExtraStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.listExtraStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/ListExtraStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_ListExtraStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.ListExtraStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.ExtraStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.listExtraStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/ListExtraStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_ListExtraStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.DeleteExtraStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteExtraStaticDataResponse>}
 */
const methodDescriptor_AriAPI_DeleteExtraStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/DeleteExtraStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.DeleteExtraStaticDataRequest,
  proto.witbooking.ari.v1.DeleteExtraStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteExtraStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.DeleteExtraStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteExtraStaticDataResponse>}
 */
const methodInfo_AriAPI_DeleteExtraStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.DeleteExtraStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteExtraStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.DeleteExtraStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.DeleteExtraStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.DeleteExtraStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.deleteExtraStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteExtraStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteExtraStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.DeleteExtraStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.DeleteExtraStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.deleteExtraStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteExtraStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteExtraStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteExtraStaticDataResponse>}
 */
const methodDescriptor_AriAPI_DeleteMultiExtraStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/DeleteMultiExtraStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest,
  proto.witbooking.ari.v1.DeleteExtraStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteExtraStaticDataResponse>}
 */
const methodInfo_AriAPI_DeleteMultiExtraStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.DeleteExtraStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteExtraStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.DeleteExtraStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.DeleteExtraStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.deleteMultiExtraStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteMultiExtraStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteMultiExtraStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.DeleteMultiExtraStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.DeleteExtraStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.deleteMultiExtraStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteMultiExtraStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteMultiExtraStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.SaveDiscountStaticDataRequest,
 *   !proto.witbooking.ari.v1.SaveDiscountStaticDataResponse>}
 */
const methodDescriptor_AriAPI_SaveDiscountStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/SaveDiscountStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.SaveDiscountStaticDataRequest,
  proto.witbooking.ari.v1.SaveDiscountStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.SaveDiscountStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.SaveDiscountStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.SaveDiscountStaticDataRequest,
 *   !proto.witbooking.ari.v1.SaveDiscountStaticDataResponse>}
 */
const methodInfo_AriAPI_SaveDiscountStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.SaveDiscountStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.SaveDiscountStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.SaveDiscountStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.SaveDiscountStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.SaveDiscountStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.SaveDiscountStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.saveDiscountStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/SaveDiscountStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_SaveDiscountStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.SaveDiscountStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.SaveDiscountStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.saveDiscountStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/SaveDiscountStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_SaveDiscountStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.GetDiscountStaticDataRequest,
 *   !proto.witbooking.ari.v1.DiscountStaticDataResponse>}
 */
const methodDescriptor_AriAPI_GetDiscountStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/GetDiscountStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.GetDiscountStaticDataRequest,
  proto.witbooking.ari.v1.DiscountStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.GetDiscountStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DiscountStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.GetDiscountStaticDataRequest,
 *   !proto.witbooking.ari.v1.DiscountStaticDataResponse>}
 */
const methodInfo_AriAPI_GetDiscountStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.DiscountStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.GetDiscountStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DiscountStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.GetDiscountStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.DiscountStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.DiscountStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.getDiscountStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetDiscountStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetDiscountStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.GetDiscountStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.DiscountStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.getDiscountStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetDiscountStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetDiscountStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.ListDiscountStaticDataRequest,
 *   !proto.witbooking.ari.v1.DiscountStaticDataResponse>}
 */
const methodDescriptor_AriAPI_ListDiscountStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/ListDiscountStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.ListDiscountStaticDataRequest,
  proto.witbooking.ari.v1.DiscountStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.ListDiscountStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DiscountStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.ListDiscountStaticDataRequest,
 *   !proto.witbooking.ari.v1.DiscountStaticDataResponse>}
 */
const methodInfo_AriAPI_ListDiscountStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.DiscountStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.ListDiscountStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DiscountStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.ListDiscountStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.DiscountStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.DiscountStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.listDiscountStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/ListDiscountStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_ListDiscountStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.ListDiscountStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.DiscountStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.listDiscountStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/ListDiscountStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_ListDiscountStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse>}
 */
const methodDescriptor_AriAPI_DeleteDiscountStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/DeleteDiscountStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest,
  proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse>}
 */
const methodInfo_AriAPI_DeleteDiscountStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.deleteDiscountStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteDiscountStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteDiscountStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.DeleteDiscountStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.deleteDiscountStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteDiscountStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteDiscountStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse>}
 */
const methodDescriptor_AriAPI_DeleteMultiDiscountStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/DeleteMultiDiscountStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest,
  proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse>}
 */
const methodInfo_AriAPI_DeleteMultiDiscountStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.deleteMultiDiscountStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteMultiDiscountStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteMultiDiscountStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.DeleteMultiDiscountStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.DeleteDiscountStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.deleteMultiDiscountStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteMultiDiscountStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteMultiDiscountStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.SaveComplementStaticDataRequest,
 *   !proto.witbooking.ari.v1.SaveComplementStaticDataResponse>}
 */
const methodDescriptor_AriAPI_SaveComplementStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/SaveComplementStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.SaveComplementStaticDataRequest,
  proto.witbooking.ari.v1.SaveComplementStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.SaveComplementStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.SaveComplementStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.SaveComplementStaticDataRequest,
 *   !proto.witbooking.ari.v1.SaveComplementStaticDataResponse>}
 */
const methodInfo_AriAPI_SaveComplementStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.SaveComplementStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.SaveComplementStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.SaveComplementStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.SaveComplementStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.SaveComplementStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.SaveComplementStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.saveComplementStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/SaveComplementStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_SaveComplementStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.SaveComplementStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.SaveComplementStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.saveComplementStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/SaveComplementStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_SaveComplementStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.GetComplementStaticDataRequest,
 *   !proto.witbooking.ari.v1.ComplementStaticDataResponse>}
 */
const methodDescriptor_AriAPI_GetComplementStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/GetComplementStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.GetComplementStaticDataRequest,
  proto.witbooking.ari.v1.ComplementStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.GetComplementStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.ComplementStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.GetComplementStaticDataRequest,
 *   !proto.witbooking.ari.v1.ComplementStaticDataResponse>}
 */
const methodInfo_AriAPI_GetComplementStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.ComplementStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.GetComplementStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.ComplementStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.GetComplementStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.ComplementStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.ComplementStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.getComplementStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetComplementStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetComplementStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.GetComplementStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.ComplementStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.getComplementStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetComplementStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetComplementStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.ListComplementStaticDataRequest,
 *   !proto.witbooking.ari.v1.ComplementStaticDataResponse>}
 */
const methodDescriptor_AriAPI_ListComplementStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/ListComplementStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.ListComplementStaticDataRequest,
  proto.witbooking.ari.v1.ComplementStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.ListComplementStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.ComplementStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.ListComplementStaticDataRequest,
 *   !proto.witbooking.ari.v1.ComplementStaticDataResponse>}
 */
const methodInfo_AriAPI_ListComplementStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.ComplementStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.ListComplementStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.ComplementStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.ListComplementStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.ComplementStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.ComplementStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.listComplementStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/ListComplementStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_ListComplementStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.ListComplementStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.ComplementStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.listComplementStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/ListComplementStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_ListComplementStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.DeleteComplementStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteComplementStaticDataResponse>}
 */
const methodDescriptor_AriAPI_DeleteComplementStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/DeleteComplementStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.DeleteComplementStaticDataRequest,
  proto.witbooking.ari.v1.DeleteComplementStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteComplementStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.DeleteComplementStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteComplementStaticDataResponse>}
 */
const methodInfo_AriAPI_DeleteComplementStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.DeleteComplementStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteComplementStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.DeleteComplementStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.DeleteComplementStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.DeleteComplementStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.deleteComplementStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteComplementStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteComplementStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.DeleteComplementStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.DeleteComplementStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.deleteComplementStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteComplementStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteComplementStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteComplementStaticDataResponse>}
 */
const methodDescriptor_AriAPI_DeleteMultiComplementStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/DeleteMultiComplementStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest,
  proto.witbooking.ari.v1.DeleteComplementStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteComplementStaticDataResponse>}
 */
const methodInfo_AriAPI_DeleteMultiComplementStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.DeleteComplementStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteComplementStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.DeleteComplementStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.DeleteComplementStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.deleteMultiComplementStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteMultiComplementStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteMultiComplementStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.DeleteMultiComplementStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.DeleteComplementStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.deleteMultiComplementStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteMultiComplementStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteMultiComplementStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.SaveBundleStaticDataRequest,
 *   !proto.witbooking.ari.v1.SaveBundleStaticDataResponse>}
 */
const methodDescriptor_AriAPI_SaveBundleStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/SaveBundleStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.SaveBundleStaticDataRequest,
  proto.witbooking.ari.v1.SaveBundleStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.SaveBundleStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.SaveBundleStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.SaveBundleStaticDataRequest,
 *   !proto.witbooking.ari.v1.SaveBundleStaticDataResponse>}
 */
const methodInfo_AriAPI_SaveBundleStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.SaveBundleStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.SaveBundleStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.SaveBundleStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.SaveBundleStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.SaveBundleStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.SaveBundleStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.saveBundleStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/SaveBundleStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_SaveBundleStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.SaveBundleStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.SaveBundleStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.saveBundleStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/SaveBundleStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_SaveBundleStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.GetBundleStaticDataRequest,
 *   !proto.witbooking.ari.v1.BundleStaticDataResponse>}
 */
const methodDescriptor_AriAPI_GetBundleStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/GetBundleStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.GetBundleStaticDataRequest,
  proto.witbooking.ari.v1.BundleStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.GetBundleStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.BundleStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.GetBundleStaticDataRequest,
 *   !proto.witbooking.ari.v1.BundleStaticDataResponse>}
 */
const methodInfo_AriAPI_GetBundleStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.BundleStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.GetBundleStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.BundleStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.GetBundleStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.BundleStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.BundleStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.getBundleStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetBundleStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetBundleStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.GetBundleStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.BundleStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.getBundleStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/GetBundleStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_GetBundleStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.ListBundleStaticDataRequest,
 *   !proto.witbooking.ari.v1.BundleStaticDataResponse>}
 */
const methodDescriptor_AriAPI_ListBundleStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/ListBundleStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.ListBundleStaticDataRequest,
  proto.witbooking.ari.v1.BundleStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.ListBundleStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.BundleStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.ListBundleStaticDataRequest,
 *   !proto.witbooking.ari.v1.BundleStaticDataResponse>}
 */
const methodInfo_AriAPI_ListBundleStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.BundleStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.ListBundleStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.BundleStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.ListBundleStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.BundleStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.BundleStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.listBundleStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/ListBundleStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_ListBundleStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.ListBundleStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.BundleStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.listBundleStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/ListBundleStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_ListBundleStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.DeleteBundleStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteBundleStaticDataResponse>}
 */
const methodDescriptor_AriAPI_DeleteBundleStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/DeleteBundleStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.DeleteBundleStaticDataRequest,
  proto.witbooking.ari.v1.DeleteBundleStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteBundleStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.DeleteBundleStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteBundleStaticDataResponse>}
 */
const methodInfo_AriAPI_DeleteBundleStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.DeleteBundleStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteBundleStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.DeleteBundleStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.DeleteBundleStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.DeleteBundleStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.deleteBundleStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteBundleStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteBundleStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.DeleteBundleStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.DeleteBundleStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.deleteBundleStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteBundleStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteBundleStaticData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteBundleStaticDataResponse>}
 */
const methodDescriptor_AriAPI_DeleteMultiBundleStaticData = new grpc.web.MethodDescriptor(
  '/witbooking.ari.v1.AriAPI/DeleteMultiBundleStaticData',
  grpc.web.MethodType.UNARY,
  proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest,
  proto.witbooking.ari.v1.DeleteBundleStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest,
 *   !proto.witbooking.ari.v1.DeleteBundleStaticDataResponse>}
 */
const methodInfo_AriAPI_DeleteMultiBundleStaticData = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.ari.v1.DeleteBundleStaticDataResponse,
  /**
   * @param {!proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.ari.v1.DeleteBundleStaticDataResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.ari.v1.DeleteBundleStaticDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.ari.v1.DeleteBundleStaticDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.ari.v1.AriAPIClient.prototype.deleteMultiBundleStaticData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteMultiBundleStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteMultiBundleStaticData,
      callback);
};


/**
 * @param {!proto.witbooking.ari.v1.DeleteMultiBundleStaticDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.ari.v1.DeleteBundleStaticDataResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.ari.v1.AriAPIPromiseClient.prototype.deleteMultiBundleStaticData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.ari.v1.AriAPI/DeleteMultiBundleStaticData',
      request,
      metadata || {},
      methodDescriptor_AriAPI_DeleteMultiBundleStaticData);
};


module.exports = proto.witbooking.ari.v1;

